module.exports = __webpack_public_path__ + "static/media/free-story-subscribe-band-mob.338be425.png";